import { ModalDismiss } from '@apps-common/config/modal'
import { IonContent, IonPage } from '@ionic/react'
import classNames from 'classnames'
import { ReactNode } from 'react'

export const MODAL_WRAPPER_X_PADDING = 'px-[1rem] sm:px-[1.5rem]'
export const MODAL_WRAPPER_Y_PADDING = 'py-[1rem] sm:py-[1.5rem]'

interface IProps {
  alwaysMobile?: boolean
  classes?: string
  innerClasses?: string
  containerClasses?: string
  children: ReactNode
  onDismiss?: (data?: string | null | undefined | number, role?: string) => void
}

const shouldApplyModalSheetPanel = (innerClasses?: string) =>
  !innerClasses?.split(/\s+/).some((className) => className === '!h-auto' || className === '!min-h-0')

export const ModalContainer = ({ alwaysMobile, classes, innerClasses, containerClasses, children, onDismiss }: IProps) => (
  <IonPage
    className='!overscroll-none'
    style={{
      '--background': 'transparent'
    }}
  >
    <IonContent
      className='!overscroll-none'
      forceOverscroll={false}
      scrollY={false}
      style={{
        '--background': 'transparent'
      }}
    >
      {/* <AnimatePresence>
        <motion.div
          {...motionFadeIn(0.25)}
          className='absolute top-0 left-0 h-[40px] w-full bg-gradient-to-b from-bg via-bg/60 to-transparent pointer-events-none'
        />
      </AnimatePresence> */}

      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div
        className={classNames(
          classes,
          'absolute min-w-full max-w-full h-[100dvh] top-0 left-0 backdrop-blur-sm flex justify-center safe-area-top overflow-hidden overflow-y-none !overscroll-none',
          alwaysMobile && 'items-end',
          !alwaysMobile && 'items-end md:items-center'
        )}
        onClick={() => {
          if (onDismiss) {
            onDismiss(null, ModalDismiss.Backdrop)
          }
        }}
      >
        {/* <div className={classNames('h-[5lvh] w-full md:h-[0px] bg-pink-50')} /> */}
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
        <div
          className={classNames(
            '!overscroll-none',
            innerClasses,
            shouldApplyModalSheetPanel(innerClasses) && 'modal-sheet-panel',
            'shadow-sm overflow-hidden relative border border-border',
            alwaysMobile && [
              '!mx-3 sm:!mx-auto w-[calc(100%-20px)] [--background:hsl(var(--rn-surface-2))] bg-surface-2 h-[95dvh] sm:h-[90vh] flex items-start justify-center rounded-t-3xl max-w-[600px]'
            ],
            !alwaysMobile && [
              '!mx-3 w-[calc(100%-10px)] [--background:hsl(var(--rn-surface-2))] bg-surface-2 h-[95dvh] flex items-start justify-center rounded-t-3xl',
              'sm:max-w-[600px] sm:h-[min(calc(100svh-100px),900px)] sm:min-h-[320px] sm:border sm:border-border md:rounded-3xl'
            ]
          )}
          onClick={(e) => {
            if (onDismiss) {
              e?.stopPropagation()
              // do nothing, prevent propagation
            }
          }}
        >
          <div
            className={classNames(
              containerClasses,
              'w-full h-[100%] flex flex-col items-start justify-between overflow-y-hidden !overscroll-none'
            )}
          >
            {children}
          </div>
        </div>
      </div>
    </IonContent>
  </IonPage>
)
